import type { Feature } from '@luna/gatekeeper';

export const limitsChange: Feature = {
    enabled: true,
    _description: 'Enables display of the refactored limit change focus page',
};
